import AppLayout from "@components/layout/AppLayout"
import React, { useState } from "react"
import { getBoerseApiUrl } from "@utils/apiBase"
import styles from "@components/dataDisplay/premarketTable/premarket.module.css"
import Closed from "@components/dataDisplay/premarketTable/Closed"
import { Segment } from "@ts/types/segment.type"
import IndexTable from "@components/dataDisplay/premarketTable/IndexTable"
import InstrumentsTable from "@components/dataDisplay/premarketTable/InstrumentsTable"
import Footer from "@components/dataDisplay/premarketTable/Footer"

interface PremarketData {
  creationTimestamp: string
  importTimestamp: string
  segments: [Segment]
  withinTradingWindow?: boolean
}

interface Response<Type> {
  status: "Success" | "Error"
  message?: string
  payload?: Type
}

async function getServerSideProps(context: any) {
  const formatter = new Intl.DateTimeFormat([], {
    timeZone: "Europe/Zurich",
    hour12: false,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  })
  const nowInZurich = formatter.format(new Date())
  const currentHour = parseInt(nowInZurich.split(":")[0])

  const isPremarket = currentHour >= 8 && currentHour < 9
  const forcePremarketShowing = !!context.query.jb

  if (!isPremarket && !forcePremarketShowing) {
    return {
      props: {
        status: "Error",
        message: "Hier erscheinen jeden Montag bis Freitag von 08:00 bis 09:00 Uhr die Vorbörsenkurse von Julius Bär.",
      },
    }
  }

  const endpointDomain = getBoerseApiUrl()
  const endpoint = `${endpointDomain}/marketdata/premarket`
  const premarketRequest = await fetch(endpoint)
  const response = await premarketRequest.json()
  const premarketData = response as Response<PremarketData>
  return { props: premarketData }
}

const Premarket = (response: Response<PremarketData>) => {
  const [segmentHead, setSegmentHead] = useState(0)
  let output: React.ReactElement | null = null

  if (response.message) {
    output = <Closed message={response.message} />
  }

  if (response.payload && response.payload.segments.length > 0) {
    output = (
      <>
        <ul className={styles.tabs}>
          {response.payload.segments.map((segment: Segment, i: number) => (
            <li
              data-test-id={segment.name.toLowerCase().replace(/ /g, "-")}
              className={`${styles.tab} ${segmentHead == i ? styles.active : ""}`}
              key={i}
            >
              <button onClick={() => setSegmentHead(i)}>{segment.name}</button>
            </li>
          ))}
        </ul>
        <IndexTable segment={response.payload.segments[segmentHead]} />
        <hr className={styles.divider} />
        <InstrumentsTable instruments={response.payload.segments[segmentHead].instruments} />
        <Footer timestamp={response.payload.creationTimestamp} />
      </>
    )
  }

  return (
    <AppLayout title="Premarket" robots="noindex,nofollow">
      {output}
    </AppLayout>
  )
}

export { getServerSideProps }
export default Premarket
